import {EntityModel} from "@fedeltapointofsale/data-client";
import {TaxData} from "./tax.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TaxEntityModel extends EntityModel<TaxData> {
    constructor(injector: Injector) {
        super(injector, TaxData);
    }
}
